import React, {Component} from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

// Actions
import {
    getScopesForYear,
    postScope,
    getIsDataEntered,
    ESGLevelTypes,
    ESGScopeTypes
} from '../../../../../actions/esg'

// Utils
import { translation } from '../../../../../utils/helpers'

// Elements
import Panel from '../../../../../shared/elements/panel'
import Col from '../../../../../shared/elements/col'
import Text from '../../../../../shared/elements/text'
import Textarea from '../../../../../shared/elements/textarea'
import RemoveButton from '../../../../../shared/elements/removeButton'

// components
import Portal from '../../../../../shared/components/Portal'
import Confirm from '../../../../../shared/components/Confirm'

// sub-components
import Categories from './categories'

class Scopes extends Component {
  constructor (props) {
    super(props)
    this.state = {
      scopes: [],
      confirm: { show: false, onConfirm: () => {} }
    }

    this.addScope = this.addScope.bind(this)
    this.onDelete = this.onDelete.bind(this)
  }

  componentDidMount () {
    this.getScopes(this.props.schemaId, this.props.year, this.props.scopeType)
  }

  componentWillReceiveProps (nextProps) {
    let { schemaId, year, scopeType } = this.props
    if (schemaId !== nextProps.schemaId || year !== nextProps.year || scopeType !== nextProps.scopeType) {
      this.getScopes(nextProps.schemaId, nextProps.year, nextProps.scopeType)
    }
  }

  getScopes (schemaId, year, scopeType) {
    this.props.getScopesForYear(schemaId, year, scopeType).then((res) => {
      this.setState({ scopes: res.data })
    }, () => {
      window.toastr.error(translation('960'), translation('216'))
    })
  }

  addScope () {
    let data = { schemaId: this.props.schemaId, year: this.props.year }
    this.props.postScope(data).then((res) => {
      this.setState({ scopes: [...this.state.scopes, res.data] })
      // window.toastr.success(translation(18416), translation('13424'))
    }, () => {
      window.toastr.error(translation(18417), translation('216'))
    })
  }

  onDelete (level, id, callback) {
    this.props.getIsDataEntered(level, id).then((res) => {
      if (res.data === false) callback() // no data is entered, delete
      else if (res.data === true) {
        this.setState({ confirm: { show: true, onConfirm: callback } })
      }
    }, () => {
      window.toastr.error(translation('960'), translation('216'))
    })
  }

  render () {
    let scopeType = this.props.scopeType

    const renderScope = (scope, index) => {
      let scopeNumber = index + 1

      const changeScopeData = (data) => {
        let scopes = [...this.state.scopes]
        scopes[index] = { ...scope, ...data }
        if (scopes[index].IsDeleted === true) scopes.splice(index, 1)
        this.setState({ scopes: scopes })
      }

      const saveScope = (overWriteObj = undefined) => {
        let data = overWriteObj || scope
        this.props.postScope(data).then((res) => {
          changeScopeData(res.data)
          // window.toastr.success(translation(893), translation('13424'))
        }, () => {
          window.toastr.error(translation(960), translation('216'))
        })
      }

      const onScopeChange = ({ target: { value, name } }) => changeScopeData({ [name]: value })
      const deleteScope = () => this.onDelete(ESGLevelTypes.Scope, scope.Id, () => saveScope({ ...scope, IsDeleted: true }))

      switch (scopeType) {
        case ESGScopeTypes.ManualReporting:
          return (
            <Col key={index} span={3}>
              <Panel title={19006}>
                <Text size='s' labelText={19007} name='Title' value={scope.Title} onChange={onScopeChange} onBlur={() => saveScope()} />
                {<Categories scopeId={scope.Id} scopeType={scopeType} categories={scope.Categories} bubbleUpChange={changeScopeData} onDelete={this.onDelete} />}
              </Panel>
            </Col>
          )
        case ESGScopeTypes.Default:
          return (
            <Col key={index} span={3}>
              <Panel title={`${translation(18406)}\u00A0${scopeNumber}`}>
                {index > 0 && <RemoveButton spacing={1} onClick={deleteScope} />}
                <Text size='s' labelText={`${translation(18414)}\u00A0${scopeNumber}`} name='Title' value={scope.Title} onChange={onScopeChange} onBlur={() => saveScope()} />
                <Textarea labelText={`${translation(18415)}\u00A0${scopeNumber}`} name='Description' value={scope.Description} onChange={onScopeChange} onBlur={() => saveScope()} />
                {<Categories scopeId={scope.Id} scopeType={scopeType} categories={scope.Categories} bubbleUpChange={changeScopeData} onDelete={this.onDelete} />}
              </Panel>
            </Col>
          )
        default:
          throw new Error(`Scope type: ${scopeType} is not implemented!`)
      }
    }

    const onConfirmClose = () => this.setState({ confirm: { show: false, onConfirm: () => {} } })
    const onConfirm = () => { this.state.confirm.onConfirm(); onConfirmClose() }
    return (
      <div>
        {this.state.scopes.map(renderScope)}
        {this.state.confirm.show !== false && (
          <Portal className='confirmModal' onPortalClose={onConfirmClose}>
            <Confirm confirm={onConfirm} notConfirm={onConfirmClose} higher renderText={() => translation(18418)} confirmText={() => translation(786)} notConfirmText={() => translation(570)} />
          </Portal>
        )}
      </div>
    )
  }
}

Scopes.propTypes = {
  schemaId: PropTypes.number.isRequired,
  year: PropTypes.number.isRequired,
  scopeType: PropTypes.oneOf(Object.values(ESGScopeTypes)).isRequired
}

export default connect(null, {
  getScopesForYear,
  postScope,
  getIsDataEntered
}, null, { withRef: true })(Scopes)



// WEBPACK FOOTER //
// ./src/app/pages/ESG/Chain/View/components/scopes.js